var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowerPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9998,
    cy: 25,
    r: 25,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 49.9997C38.8072 49.9997 50 38.8069 50 24.9997C50 20.6935 48.9113 16.6416 46.994 13.1042C42.5996 9.26696 36.8503 6.94238 30.5581 6.94238C16.751 6.94238 5.55811 18.1353 5.55811 31.9424C5.55811 36.2486 6.64687 40.3006 8.56412 43.8379C12.9585 47.6752 18.7078 49.9997 25 49.9997Z",
    fill: "#FEFEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10174_37665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9997 23.9H26.0998V15.9999C26.0998 15.3928 25.607 14.9 24.9997 14.9C24.3926 14.9 23.8998 15.3928 23.8998 15.9999V23.9H15.9997C15.3926 23.9 14.8998 24.3928 14.8998 24.9999C14.8998 25.6072 15.3926 26.1001 15.9997 26.1001H23.8998V33.9999C23.8998 34.6072 24.3926 35.1001 24.9997 35.1001C25.607 35.1001 26.0998 34.6072 26.0998 33.9999V26.1001H33.9997C34.607 26.1001 35.0998 25.6072 35.0998 24.9999C35.0998 24.3928 34.607 23.9 33.9997 23.9Z",
    fill: "#121212",
    stroke: "black",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10174_37665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13.9998 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlus);
export default __webpack_public_path__ + "static/media/powerPlus.31ca8bf021d7a91021dddb1f219c3866.svg";
export { ForwardRef as ReactComponent };